<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">

    <div class="absolute inset-0 z-10 overflow-hidden green-noise-bg flex items-center justify-center">

        <button type="button" (click)="closePanel()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>


        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2 min-h-0">



            <div class="w-full flex-0 border-b border-white/10 pb-2">
                <h3 class="text-base font-semibold text-primary">Create Compliance Guide</h3>
                <p class="mt-1 text-sm text-secondary">Add compliance guidelines, regulatory requirements, and audit
                    tools for content moderation.</p>
            </div>


            @if (submittingCompliance()) {
            <div class="h-full w-full flex items-center justify-center">
                <atom-loading-inline [title]="'Creating Compliance Document'"
                    [message]="'Please wait while we create the compliance document.'"></atom-loading-inline>
            </div>

            } @else if (complianceCreated()) {
            <div class="h-full w-full flex items-center justify-center">
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                        <circle cx="12" cy="12" r="10" />
                        <path d="m9 12 2 2 4-4" />
                    </svg>
                    <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Success!</h3>
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">The compliance document has been created
                        successfully.</p>
                    <div class="mt-6">
                        <button (click)="closePanel()" type="button"
                            class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="mr-1.5 -ml-0.5 size-5">
                                <path
                                    d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                            </svg>
                            Done
                        </button>
                    </div>
                </div>

            </div>

            } @else {
            <div class="flex-1 w-full min-h-0 overflow-y-auto scrollbar-transparent">



                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 px-2">

                    <div class="sm:col-span-3">
                        <label for="first-name" class="block text-sm/6 font-medium text-primary">Compliance Name</label>
                        <div class="mt-2">
                            <input [formField]="complianceForm.complianceName" id="compliance-name" type="text"
                                class="input-primary text-primary" />
                            @if (complianceForm.complianceName().touched() &&
                            complianceForm.complianceName().invalid()) {
                            <ul class="error-list">
                                @for (error of complianceForm.complianceName().errors(); track error) {
                                <li class="text-error-light flex items-start gap-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                        <path
                                            d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                        <path d="M12 9v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                    {{ error.message }}
                                </li>
                                }
                            </ul>
                            }
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">Compliance
                            Description</label>
                        <div class="mt-2">
                            <textarea [formField]="complianceForm.description" id="comment" rows="3"
                                placeholder="A sentence or two describing the compliance document. This will help you find the document when you're looking for it."
                                class="input-textarea text-primary"></textarea>
                            @if (complianceForm.description().touched() &&
                            complianceForm.description().invalid()) {
                            <ul class="error-list">
                                @for (error of complianceForm.description().errors(); track error) {
                                <li class="text-error-light flex items-start gap-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                        <path
                                            d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                        <path d="M12 9v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                    {{ error.message }}
                                </li>
                                }
                            </ul>
                            }
                        </div>
                    </div>

                    <div class="sm:col-span-full">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">
                            How would you like to provide the compliance document?
                        </label>

                        <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6">
                            @for (type of briefProvisionOptions; track type.id) {
                            <li class="col-span-1 flex rounded-md" (click)="selectedComplianceProvision.set(type)"
                                [class]="selectedComplianceProvision()?.id === type.id ? 'border-primary' : 'border-zinc-500'">
                                <div
                                    class="flex w-16 shrink-0 items-center justify-center text-sm font-medium rounded-l-md border-t border-l border-b border-zinc-300 dark:border-white/10 text-secondary">
                                    @switch (type.id) {
                                    @case (1) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-8">
                                        <path d="M12 3v12" />
                                        <path d="m17 8-5-5-5 5" />
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    </svg>
                                    }
                                    @case (2) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-8">
                                        <path
                                            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                        <path d="M10 9H8" />
                                        <path d="M16 13H8" />
                                        <path d="M16 17H8" />
                                    </svg>
                                    }
                                    }
                                </div>

                                <div
                                    class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                                    <div class="flex-1 truncate px-4 py-2 text-sm">
                                        <a class="font-medium text-primary hover:text-gray-200">{{ type.name
                                            }}</a>
                                        <p class="text-secondary truncate">{{ type.description }}</p>
                                    </div>
                                    <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                        @if (selectedComplianceProvision()?.id === type.id) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-6">
                                            <circle cx="12" cy="12" r="10" />
                                            <path d="m9 12 2 2 4-4" />
                                        </svg>
                                        }
                                    </div>
                                </div>

                            </li>
                            }
                        </ul>
                    </div>

                    @if (selectedComplianceProvision()?.id === 1) {
                    <div class="sm:col-span-full">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">
                            Upload Brief Document
                        </label>

                        <div class="mt-3 w-full overflow-hidden">
                            <atom-add-document (documentUploaded)="onDocumentUploaded($event)"></atom-add-document>
                        </div>
                    </div>
                    }

                    @if (selectedComplianceProvision()?.id === 2) {
                    <div class="sm:col-span-full">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">
                            Compliance Content
                            <p class="text-xs text-secondary">Create a compliance document by typing the content.</p>
                        </label>
                        <div class="mt-2">
                            <atom-wysiswyg (htmlContentChange)="onHtmlContentChange($event, 'key')"
                                [placeholder]="'Type here...'"></atom-wysiswyg>
                        </div>
                    </div>
                    }
                </div>

                <!-- <div
                    class="col-span-full mt-6 flex items-center justify-end gap-x-6 w-full border-t border-zinc-500/10 dark:border-zinc-800 pt-4">
                    <button (click)="saveCompliance()" type="button" class="primary-button">Save</button>
                </div> -->


            </div>

            <div class="w-full flex-0 border-t border-white/10 pt-2">
                <div class="flex flex-row items-center justify-between gap-x-2">
                    <button (click)="closePanel()" type="button" class="secondary-button text-secondary">Cancel</button>
                    <button (click)="saveCompliance()" type="button" class="primary-button">Save</button>
                </div>
            </div>
            }


        </div>

    </div>
</div>